import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { AnnexPage } from '@/features/annexes/annexes'
import { usePanelStore } from '@/components/conversation/panel-store'

export const Route = createFileRoute('/_layout/_app/annexes/$id')({
  component: AnnexesRoute,
  staticData: { title: 'Aneksi' },
})

function AnnexesRoute() {
  const { id } = Route.useParams()
  const closePanel = usePanelStore((s) => s.closePanel)

  useEffect(() => {
    closePanel(true)
  }, [id])

  useEffect(() => {
    return () => closePanel(true)
  }, [])

  return <AnnexPage id={id} />
}
